import * as Actions from '../../actions/campaigner/types';

const initialState = {
  loading: false,
  campaigns: null,
  getCampaignsLoading: false,
};

const campaignerReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Campaigns
    case Actions.GET_CAMPAIGNS_REQUEST:
      return { ...state, getCampaignsLoading: true };

    case Actions.GET_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        getCampaignsLoading: false,
        campaigns: action.payload || '',
      };

    case Actions.GET_CAMPAIGNS_FAILURE:
      return {
        ...state,
        getCampaignsLoading: false,
        error: action.payload,
      };

    case Actions.UPDATE_CAMPAIGN:
      const index = state.campaigns.findIndex((c) => c?.id === action?.payload?.id);
      const updatedCampaigns = state.campaigns;
      updatedCampaigns[index] = action?.payload?.campaign;

      return {
        ...state,
        campaigns: updatedCampaigns,
      };

    default:
      return state;
  }
};

export default campaignerReducer;
